module.exports = __webpack_public_path__ + "static/media/ts.a99704ed.svg";